import React, { useEffect, useState } from "react";

import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faUpload } from "@fortawesome/free-solid-svg-icons";
import { Image } from "react-bootstrap";
import { PDFDownloadLink, Document, Page, View, StyleSheet } from "@react-pdf/renderer";
import Html from "react-pdf-html";
import swal from "sweetalert";
import Gif from "./Spinner-3.gif";
import Load from "./Loading-bar.gif";
import Search from "./search.png";
import Citation from "./Citation.png";
import Conclusion from "./conclusion.png";
import Google from "./google.png";
import Notequal from "./Notequal.png";
import Upload from "./upload.png";
import Detect from "./detect.png";
import Arrow from "./arrow (1).png";

import "bootstrap/dist/css/bootstrap.css";
import "./App.css";
const styles = StyleSheet.create({
  page: {
    fontSize: 6,
    paddingTop: 30,
    paddingLeft: 60,
    paddingRight: 60,
    paddingBottom: 30,
  },
  text: {
    marginBottom: 10,
    fontSize: 6,
  },
});
const FileUpload = () => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [highlightedText, setHighlightedText] = useState("");
  const [wordCounts, setWordCounts] = useState({});
  const [isFileSelected, setIsFileSelected] = useState(false);
  const [showLoadingScreen, setShowLoadingScreen] = useState(false);
  const [outputPDFFfileName__, setOutputPDFFfileName__] = useState("");
  const [google_title, setGoogle_title] = useState("");
  const [title, setTitle] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [selfCitationData, setSelfCitationData] = useState("");
  const [refCitationData, setRefCitationData] = useState("");
  const [googletitle_link, setGoogletitle_link] = useState("");
  // const [userData, setUserData] = useState("");
  const [abbreviation, setAbbreviation] = useState("");
  const [statusCode, setStatusCode] = useState(null);
  const [error, setError] = useState(null);
  const [wordCountLimit, setWordCountLimit] = useState(localStorage.getItem("word_count") || 0);
  const [word_contain, setWord_contain] = useState("");
  const [word_containstart, setWord_containstart] = useState("");
  const [references, setReferences] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    // alert("PDF upload feature has been recently updated!");

    const fetchUserData = async () => {
      try {
        const accessToken = localStorage.getItem("token");
        if (!accessToken) {
          window.location.href = "/";
        }

        const response = await axios.get(process.env.REACT_APP_API_URL + "/user", {
          headers: { Authorization: `Bearer ${accessToken}` },
        });

        const data = response.data.data;
        // setUserData(response.data.data);
        localStorage.setItem("user_id", data._id);
        localStorage.setItem("user_name", data.name);
        localStorage.setItem("user_email", data.email);
        localStorage.setItem("user_role", data.role);
        localStorage.setItem("word_count", data.wordCount);
        setWordCountLimit(data.wordCount);
      } catch (error) {
        // console.log("Error ",error);
      }
    };
    fetchUserData();
  }, []);
  const handleFileUpload = (event) => {
    setFile(event.target.files[0]);
    setFileName(event.target.files[0].name);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!file) {
        setShowLoadingScreen(false);
        return alert("Please choose file to upload !!");
      }
      setShowLoadingScreen(true);
      const formData = new FormData();
      formData.append("file", file);

      formData.append("references", references);

      const accessToken = localStorage.getItem("token");

      if (!accessToken) {
        window.location.href = "/";
      }
      const response = await axios.post(process.env.REACT_APP_API_URL + "/upload", formData, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      setShowLoadingScreen(false);
      const {
        highlightedText,
        wordCounts,
        wordcontainCounts,
        wordContainStartCounts,
        google_title: searchGoogleForTitle,
        filename,
        selfcitationdata,
        abbvHighlightedText,
        abbv_list,
        referenceCitationInAbstractandConclusion,
        word_count_limit,
        referenceMatch,
      } = response.data;

      setResults(referenceMatch);
      setWord_contain(wordcontainCounts);
      setWord_containstart(wordContainStartCounts);
      console.log("data", response.data);
      updateWordCountLimit(word_count_limit);
      setSelfCitationData(selfcitationdata);
      //console.log(referenceCitationInAbstractandConclusion);
      setRefCitationData(referenceCitationInAbstractandConclusion);
      // console.log("Self_Citation", selfcitationdata);
      setAbbreviation(abbv_list);
      // console.log("Abrreviation: ", abbreviation);
      if (selfcitationdata.matchingResult !== "Not found") {
        setGoogletitle_link(selfcitationdata.matchingResult.link);
      }
      const fileNameParts = filename.split(".");
      fileNameParts.pop();
      const outputPDFFfileName = `${fileNameParts.join(".")}_phrases_found.pdf`;
      setOutputPDFFfileName__(outputPDFFfileName);
      setHighlightedText(highlightedText);
      setWordCounts(wordCounts);
    } catch (error) {
      console.error("error:", error);
      setHighlightedText("");
      if (error.response.data.word_count_limit) {
        updateWordCountLimit(error.response.data.word_count_limit);
      }

      if (error.response.data.message) {
        swal("an error occured while processing your document", error.response.data.message, "error");
      } else {
        swal("an error occured while processing your document", "file not support", "error");
      }

      setShowLoadingScreen(false);
    }
  };

  const updateWordCountLimit = (word_count) => {
    localStorage.setItem("word_count", word_count);
    setWordCountLimit(word_count);
  };

  const MyDocument = () => (
    <Document>
      <Page size="A4" style={styles.page}>
        <View>
          <Html style={{ fontSize: "12px", fontFamily: "Times New Roman" }}>{highlightedText}</Html>
        </View>
      </Page>
    </Document>
  );

  const handleClearDocument = () => {
    setShowLoadingScreen(true);
    setHighlightedText("");
    setWordCounts("");
    setFile(null);
    setFileName("");
    setShowLoadingScreen(false);
  };

  const loadingScreen = () => {
    return (
      <div
        className="d-flex display-5 justify-content-center align-items-center"
        style={{
          position: "fixed",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: "10",
          backgroundColor: "#FFFFF7 ",
        }}
      >
        <div className="text-light">
          <div className="text-center">
            <Image src={Gif} alt="TP Detector Logo" style={{ width: "70px", height: "auto" }} className="display-3" />
          </div>
          <div className="text-center">
            <Image src={Load} alt="TP Detector Logo" style={{ width: "100px", height: "auto" }} className="display-3 my-auto" />
          </div>
        </div>
      </div>
    );
  };

  const colors = [
    "#FF0000",
    "#0000FF",
    "#FF00FF",
    "#808000",
    "#FFA500",
    "#000000",
    "#808080",
    "#3CB371",
    "#57E964",
    "#FDBD01",
    "#D4A017",
    "#513B1C",
    "#EB5406",
    "#F62217",
    "#810541",
    "#F8B88B",
    "#FF00FF",
    "#BA55D3",
    "#800080",
  ];
  const wordMatchColor = {};
  let nextMatchColor = 0;

  const textStyle = {
    color: "#000c",
    fontSize: "50px",
  };
  const header = {
    textShadow: "1px 1px solid",
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("user_name");
    localStorage.removeItem("user_email");
    localStorage.removeItem("user_role");
    localStorage.removeItem("word_count");
    window.location.href = "/";
  };

  const handleDashboard = () => {
    window.location.href = "/dashboard";
  };

  // Function to send references to the backend
  // const sendReferences = async () => {
  //   try {
  //     const response = await axios.post(process.env.REACT_APP_API_URL + 'references', { references });

  //     if (response.status === 200) {
  //       alert('References submitted successfully');
  //       setResults(response.data.results); // Store results in state
  //     } else {
  //       alert('Failed to submit references');
  //     }
  //   } catch (error) {
  //     console.error('Error submitting references:', error);
  //     alert('An error occurred while submitting the references.');
  //   }
  // };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        {showLoadingScreen && loadingScreen()}
        <div className="animationContainer">
          <div className="app">
            <div className="container display-4  pt-5 pb-3" style={textStyle}>
              <h4 class="d-inline-flex bd-highlight border border text-dark display-5 rounded p-2">TP Detector</h4>
              <button
                className="btn btn border border-dark bg-white position-absolute"
                style={{
                  position: "fixed",
                  left: "80%",
                  transform: "translateX(-20%)",
                }}
                onClick={handleLogout}
              >
                Logout
              </button>{" "}
              <div className="d-flex justify-content-between">
                <button className="btn btn border border-danger bg-white" onClick={handleDashboard}>
                  {" "}
                  Dashboard{" "}
                </button>
                <div className="btn btn-danger h5">
                  Word Count Limit:{" "}
                  <big className="ms-2" style={{ fontSize: "1.5rem" }}>
                    {wordCountLimit}
                  </big>
                </div>
              </div>
            </div>
            <br />
            <div></div>
            <div>
              <div className="text-center mb-2">
                <h3 className="mt-2">
                  <b>Enter the references:</b>
                </h3>
              </div>

              <div className="text-center mb-5" style={{ textAlign: "center", marginBottom: "20px" }}>
                <textarea
                  id="references"
                  name="references"
                  rows="8"
                  // cols="150"
                  value={references}
                  onChange={(e) => setReferences(e.target.value)}
                  style={{
                    width: "100%",
                    maxWidth: "1200px",
                    minWidth: "300px",
                    padding: "10px",
                    fontSize: "1rem",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    resize: "vertical",
                    height: "auto",
                  }}
                ></textarea>
              </div>
            </div>

            <div className="row  justify-content-center" style={{ transition: "all .3s" }}>
              <div className="mb-5  col-lg-4">
                <div class="parent me-3">
                  <div className=" file-upload mx-auto">
                    <div>
                      <Image src={Upload} alt="TP Detector Logo" style={{ width: "70px", height: "auto" }} className="display-3" />
                      <h3 className="mt-3">
                        <b>Choose Browse File from Device</b>
                      </h3>
                      <input type="file" accept=".doc,.docx,.pdf" onChange={handleFileUpload} required />
                    </div>
                  </div>{" "}
                  {fileName && <div class="small my-1">{fileName}</div>}
                  <div class="small my-1 text-danger">Max Upload Size: 12 MB</div>
                  &nbsp;&nbsp;
                  <button onClick={handleSubmit} type="submit" className="upload-button btn-block w-100">
                    {" "}
                    <FontAwesomeIcon icon={faUpload} />
                    Upload
                  </button>
                  <div style={{ cursor: "pointer" }} onClick={handleClearDocument} className="text-primary p-0 bg-transparent mt-4 text-end">
                    <FontAwesomeIcon icon={faTrash} className="me-2" /> <b>Reset</b>{" "}
                  </div>{" "}
                </div>
              </div>
              {highlightedText && (
                <div className=" mb-5 col-lg-6 parent m-0">
                  <div className="mx-auto ">
                    {highlightedText && Object.keys(wordCounts).length < 1 && (
                      <div>
                        <h6 style={header}>
                          <Image src={Arrow} alt="TP Detector Logo" style={{ width: "30px", height: "auto" }} className="display-3" />
                          &nbsp;<b>Torture Phrases Found:</b> NIL
                        </h6>
                        <hr />
                      </div>
                    )}
                    {Object.keys(wordCounts).length > 0 && (
                      <div>
                        <h6 style={header}>
                          <Image src={Arrow} alt="TP Detector Logo" style={{ width: "30px", height: "auto" }} className="display-3" />
                          &nbsp;<b>Torture Phrases Found:</b>
                        </h6>
                        <ul>
                          {Object.entries(wordCounts).map(([word, count]) => {
                            if (!wordMatchColor[word]) {
                              wordMatchColor[word] = colors[nextMatchColor];
                              nextMatchColor++;
                              if (nextMatchColor === colors.length) {
                                nextMatchColor = 0;
                              }
                            }
                            return (
                              <li style={{ color: wordMatchColor[word] }} key={word}>
                                {" "}
                                {word}: {count}{" "}
                              </li>
                            );
                          })}
                        </ul>
                        <hr />
                      </div>
                    )}{" "}
                    <br />
                    {selfCitationData.selfCitationData.length > 0 || selfCitationData.selfCitationData.length < 1 ? (
                      <div>
                        <h6>
                          {" "}
                          <Image src={Arrow} alt="TP Detector Logo" style={{ width: "30px", height: "auto" }} className="display-3" />
                          &nbsp;<b>Self Citation Count:</b> NIL
                        </h6>
                        <hr />
                      </div>
                    ) : (
                      <>
                        <h6>
                          <Image src={Arrow} alt="TP Detector Logo" style={{ width: "30px", height: "auto" }} className="display-3" />
                          &nbsp;<b>Self Citation Count</b>
                        </h6>
                        <div>
                          {selfCitationData.selfCitationData.map((item, index) => {
                            if (item.count > 0) {
                              return (
                                <div key={index}>
                                  {item.name} - {item.count}
                                </div>
                              );
                            } else {
                              return null;
                            }
                          })}
                          <hr />
                        </div>
                      </>
                    )}
                    <br />
                    {refCitationData.matches.length === 0 ? (
                      <div>
                        <h6>
                          <Image src={Arrow} alt="TP Detector Logo" style={{ width: "30px", height: "auto" }} className="display-3" />
                          &nbsp;<b>Found in Abstract/Conclusion Section:</b> NIL
                        </h6>
                      </div>
                    ) : (
                      <div>
                        <h6>
                          <Image src={Arrow} alt="TP Detector Logo" style={{ width: "30px", height: "auto" }} className="display-3" />
                          &nbsp;{" "}
                          <b>
                            {" "}
                            Found in Abstract/
                            <wbr />
                            Conclusion Section:
                          </b>
                        </h6>
                        <hr />
                        <ul>
                          {refCitationData.matches.map((item, index) => (
                            <li key={index}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                    <hr />
                    <br />
                    <div>
                      <h6>
                        <Image src={Arrow} alt="TP Detector Logo" style={{ width: "30px", height: "auto" }} className="display-3" />
                        &nbsp;<b>Similar title: Available Link - </b>{" "}
                        {googletitle_link ? (
                          <a target="blank" href={googletitle_link}>
                            Matched-Link
                          </a>
                        ) : (
                          "Not found"
                        )}
                      </h6>

                      <hr />
                    </div>
                    <br />
                    {Object.keys(abbreviation).length === 0 ? (
                      <div>
                        <h6>
                          <Image src={Arrow} alt="TP Detector Logo" style={{ width: "30px", height: "auto" }} className="display-3" />
                          &nbsp;<b>Unmatched Abbreviations: NIL</b>
                        </h6>
                      </div>
                    ) : (
                      <div>
                        <h6>
                          <Image src={Arrow} alt="TP Detector Logo" style={{ width: "30px", height: "auto" }} className="display-3" />
                          &nbsp;<b>Unmatched Abbreviations:</b>
                        </h6>
                        <ul>
                          {Object.keys(abbreviation).map((key) => (
                            <li key={key}>
                              {key} - {abbreviation[key]}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    <hr />
                    <br />
                    {Object.keys(word_contain).length === 0 ? (
                      <div>
                        <h6>
                          <Image src={Arrow} alt="TP Detector Logo" style={{ width: "30px", height: "auto" }} className="display-3" />
                          &nbsp;<b>Detect Sentences that contain: NIL</b>
                        </h6>
                      </div>
                    ) : (
                      <div>
                        <h6>
                          <Image src={Arrow} alt="TP Detector Logo" style={{ width: "30px", height: "auto" }} className="display-3" />
                          &nbsp;<b>Detect Sentences that contain:</b>
                        </h6>
                        <ul>
                          {Object.keys(word_contain).map((key) => (
                            <li key={key}>
                              {key} - {word_contain[key]}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    <hr />
                    <br />
                    {Object.keys(word_containstart).length === 0 ? (
                      <div>
                        <h6>
                          <Image src={Arrow} alt="TP Detector Logo" style={{ width: "30px", height: "auto" }} className="display-3" />
                          &nbsp;<b>Detect sentences that start with: NIL</b>
                        </h6>
                      </div>
                    ) : (
                      <div>
                        <h6>
                          <Image src={Arrow} alt="TP Detector Logo" style={{ width: "30px", height: "auto" }} className="display-3" />
                          &nbsp;<b>Detect sentences that start with:</b>
                        </h6>
                        <ul>
                          {Object.keys(word_containstart).map((key) => (
                            <li key={key}>
                              {key} - {word_containstart[key]}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    <hr />
                    <br />
                    <h6>
                      <Image src={Arrow} alt="TP Detector Logo" style={{ width: "30px", height: "auto" }} className="display-3" />
                      &nbsp;<b>Reference match summary:</b>
                    </h6>
                    {results.length > 0 ? (
                      <div style={{ marginBottom: "20px", padding: "10px" }}>
                        {results.map((result, index) => (
                          <div key={index}>
                            <p style={{ fontSize: "0.9rem" }}>
                              <span>{index + 1}.&nbsp;</span>
                              <span style={{ marginRight: "30px" }}>Perfect match: {result.isPerfectMatch ? "Yes" : "No"}</span>
                              <span>
                                {result.isPerfectMatch && result.URL ? (
                                  <a href={result.URL} target="_blank" rel="noopener noreferrer">
                                    Review match
                                  </a>
                                ) : (
                                  <span style={{ opacity: 0.5, textDecoration: "none", cursor: "default" }}>No match</span>
                                )}
                              </span>
                            </p>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p>No results yet. Submit references to see the output.</p>
                    )}
                    <br />
                    {highlightedText && (
                      <div className="text-center">
                        <PDFDownloadLink className="btn btn-danger " document={<MyDocument />} fileName={outputPDFFfileName__}>
                          {({ loading }) => (loading ? "Loading document..." : "Download as PDF")}
                        </PDFDownloadLink>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default FileUpload;
